<template>

    <div class="sticky-header sticky-lg-top shadow-sm">

        <template v-if="$page.props.app.theme == 'dentalink'">
            <div class="bg-light">
                <nav class="nav nav-fill border-bottom">
                    <inertia-link :href="route('home')" class="nav-link px-5 py-2 rounded-0" :class="{'active fw-bold bg-primary link-light': !route().current('test.materials')}">
                        Beschaffung
                    </inertia-link>
                    <inertia-link :href="route('test.materials')" class="nav-link px-5 py-2 link-dark rounded-0" :class="{'active fw-bold bg-primary link-light': route().current('test.materials')}">
                        Materiallager
                    </inertia-link>
                    <inertia-link :href="route('test.marketing')" class="nav-link px-5 py-2 link-dark rounded-0">
                        Marketing
                    </inertia-link>
                </nav>
            </div>
        </template>

        <!--@todo als zone?-->
        <top-bar v-if="$page.props.app.theme == 'dentagen'" />

        <header class="header">

            <nav class="navbar navbar-light">
                <div class="container justify-content-start">

                    <button class="navbar-toggler border-0 px-2 d-inline d-md-none" 
                            type="button" 
                            data-bs-toggle="offcanvas" 
                            data-bs-target="#offcanvasNavbar" 
                            aria-controls="offcanvasNavbar">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <offcanvas-menu />

                    <div class="col-lg-auto order-0">
                        <inertia-link :href="route('home')">
                            <img :src="$page.props.app.logo"
                                 class="navbar-brand logo"
                                 :alt="$page.props.app.name"
                                 >
                        </inertia-link>
                    </div>

                    <div class="col-lg-auto btn-group btn-group-sm gap-2 gap-lg-3 align-items-center order-1 order-md-2 ms-auto">

                        <template v-if="$page.props.app.theme == 'dentalink'">
                            <inertia-link :href="route('test.rewards')" class="position-relative fs-4 text-warning text-decoration-underline">
                                <i class="bi bi-shield-check"></i>
                                <span class="">
                                    Silber
                                </span>
                            </inertia-link>
                        </template>

                        <inertia-link class="btn text-nowrap header-btn d-flex align-items-center"
                                      :href="route('cart.index')"
                                      :title="__('Cart')"
                                      data-bs-toggle="offcanvas@todo"
                                      data-bs-target="#offcanvasCart"
                                      aria-controls="offcanvasCart">
                            <span class="d-block position-relative">
                                <span class="icon-cart" v-if="$page.props.app.theme == 'dentalink'">
                                    <i class="bi bi-cart2"></i>
                                </span>
                                <img src="/img/icons/shopping-cart@2x.svg" alt="" class="img-fluid" v-else />
                                <span class="btn-badge">
                                    {{ $page.props.shop.totalCartItems || 0 }}
                                </span>
                            </span>
                            <span class="ms-3 d-none d-md-inline-block" style="vertical-align: super">
                                {{ $page.props.shop.totalCartAmount || 0 | localizeAmount }}
                            </span>
                        </inertia-link>

                        <inertia-link class="btn header-btn"
                                      :href="route('watchlist.index')"
                                      :title="__('Watchlist')">
                            <span class="d-block position-relative">
                                <span class="icon-watchlist" v-if="$page.props.app.theme == 'dentalink'">
                                    <i class="bi bi-pin-angle"></i>
                                </span>
                                <img src="/img/icons/pin@2x.svg" alt="" class="img-fluid" v-else />
                                <span class="btn-badge">
                                    {{ $page.props.shop.totalWatchlistItems }}
                                </span>
                            </span>
                        </inertia-link>

                        <inertia-link class="btn d-none d-md-block header-btn"
                                      :href="route('messages.index')"
                                      :title="__('Messages')">
                            <span class="d-block position-relative">
                                <span class="icon-messages" v-if="$page.props.app.theme == 'dentalink'">
                                    <i class="bi bi-envelope"></i>
                                </span>
                                <img src="/img/icons/envelope@2x.svg" alt="" class="img-fluid" v-else />
                                <span class="btn-badge">
                                    {{ $page.props.shop.totalUnreadMessages }}
                                </span>
                            </span>
                        </inertia-link>

                        <div v-if="$page.props.auth.user" class="ps-1">
                            <inertia-link 
                                id="accountDropdown" 
                                class="btn py-1 px-1 d-flex align-items-center header-btn" 
                                :href="route('account.index')"
                                role="button" 
                                data-bs-toggle="dropdown">
                                <avatar class="me-2" :user="$page.props.auth.user" v-if="$page.props.auth.user" />
                                <span class="d-none d-xl-block">
                                    {{ $page.props.auth.user.full_name }}
                                </span>
                            </inertia-link>
                            <div class="dropdown-menu dropdown-menu-end">
                                <template v-for="menuItem in $page.props.userMenuItems">
                                    <a class="dropdown-item" :href="menuItem.url">
                                        {{ menuItem.label }}
                                    </a>
                                </template>
                                <!--                                    <inertia-link class="dropdown-item" :href="route('users.edit', $page.props.auth.user)">
                                                                        {{ __('Mein Profil') }}
                                                                    </inertia-link>
                                                                    <inertia-link class="dropdown-item" :href="route('orders.index')">
                                                                        {{ __('Bestellungen') }}
                                                                    </inertia-link>
                                                                    <a class="dropdown-item" :href="route('admin.dashboard.index')">
                                                                        {{ __('Admin') }}
                                                                    </a>-->
                                <inertia-link 
                                    class="dropdown-item"
                                    :href="route('impersonate.leave')"
                                    v-if="$page.props.auth.user.is_impersonating"
                                    >
                                    {{ __('Zu ursprünglichem Benutzer zurückkehren') }}
                                </inertia-link>
                                <inertia-link class="dropdown-item" :href="route('logout')" method="post" as="button" type="button">
                                    {{ __('Logout') }}
                                </inertia-link>
                                <!--                               @todo     <a class="dropdown-item" :href="route('oauth.logout')">
                                                                        {{ __('Logout bei DENTAGEN') }}
                                                                    </a>-->
                            </div>
                        </div>

                        <template v-else>
                            <inertia-link class="btn py-1 px-1" :href="route('register')" v-if="$page.props.canRegister">
                                {{ __('Register') }}
                            </inertia-link>
                            <inertia-link class="btn py-1 px-1" :href="route('login')">
                                {{ __('Login') }}
                            </inertia-link>
                        </template>

                    </div>

                    <div class="col-12 col-lg order-2 order-lg-1 mx-xl-5">
                        <search-form />
                    </div>

                </div>
            </nav>

            <top-menu v-if="$page.props.app.theme == 'dentalink'" />

        </header>

    </div>

</template>


<script>

    import Avatar from '@/shared/Avatar';
    import SearchForm from '@/shared/SearchForm';
    import MainMenu from '@/shared/MainMenu';
    import OffcanvasMenu from '@/shared/OffcanvasMenu';
    import TopBar from '@/shared/TopBar';
    import TopMenu from '@/shared/TopMenu';

    export default {
        props: [
        ],
        data() {
            return {

            }
        },
        components: {
            Avatar,
            SearchForm,
            MainMenu,
            OffcanvasMenu,
            TopBar,
            TopMenu,
        },
    }
</script>